import * as React from 'react';
import { manageBookingReturnLink as trackManageBookingReturnLink } from 'lib/gaTracking/crossPageEvents';
import { useDetailsBooking, useScrollTopOnMount, useTitleOnMount } from 'lib/hooks';
import * as links from 'lib/links';

import PageHeader from 'components/PageHeader';
import ChangeDatesFlow from './ChangeDatesFlow';
import { useCanAmendDatesGuard } from './hooks/useCanAmendDatesGuard';
import { withChangeDatesProvider } from './ChangeDatesProvider';

const ChangeDatesPage: React.FC = () => {
  const { booking } = useDetailsBooking();

  useCanAmendDatesGuard(booking.id, booking.flags.isDateAmendableInApp);
  useTitleOnMount(`Date Change for ${booking.reference}`);
  useScrollTopOnMount();

  return (
    <>
      <PageHeader
        title="Change booking"
        bookingRef={booking.reference}
        backLinkTitle="Manage your booking"
        backLinkUrl={links.getBookingDetailsPageLink(booking.id)}
        onClickBackLink={trackManageBookingReturnLink}
      />
      <ChangeDatesFlow />
    </>
  );
};

export default withChangeDatesProvider(ChangeDatesPage);
